<template>
  <PreloaderComponent v-show="!isLoaded" />
  <div v-show="isLoaded" class="icsl">
    <p class="icsl__header" v-if="contract.number && contract.date">
      {{ agreementInfoComputed }}
    </p>
    <p class="icsl__text icsl__text_mt">Уважаемый клиент, перед подачей заявления о страховой выплате,
      пожалуйста, ознакомьтесь c
      <a target="_blank" href="https://makclife.ru/insurance-cases.php">памяткой</a>,
      в которой находятся все необходимые данные о перечне документов, которые необходимо предоставить в компанию.
    </p>
    <br>
    <p class="icsl__text">Если вы желаете заполнить заявление вручную, можете
      <a target="_blank"
         href="https://makclife.ru/upload/iblock/4ee/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%BE%D0%B9%20%D0%B2%D1%8B%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%20%D0%B2%20%D1%81%D0%BB%D1%83%D1%87%D0%B0%D0%B5%20%20%D0%B4%D0%B8%D0%B0%D0%B3%D0%BD%D0%BE%D1%81%D1%82%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F%20%D0%BA%D1%80%D0%B8%D1%82%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%BE%D0%B3%D0%BE%20%D0%B7%D0%B0%D0%B1%D0%BE%D0%BB%D0%B5%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F%20%D0%97%D0%B0%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%B0%D0%BD%D0%BD%D0%BE%D0%B3%D0%BE%20%D0%BB%D0%B8%D1%86%D0%B0.pdf">скачать
        бланк</a> заявления.
    </p>
    <div class="icsl__statement-div">
      <label>
        <input type="radio" name="type" id="type" @click="errors = []; files= []" v-model="type" :value="'e_statement'">
        <span>Электронное заявление</span>
      </label>
      <label>
        <input type="radio" name="type" id="type" @click="errors = []; files= []" v-model="type" :value="'f_statement'">
        <span>Заявление, заполненное вручную</span>
      </label>
    </div>
    <h1 v-if="type === 'e_statement'" class="icsl__subheader">Заявление по страховому событию</h1>
    <div v-if="type === 'e_statement'" class="icsl__infoWrapper">
      <div class="icsl__infoWrapper-row">
        <div class="icsl__infoWrapper-input">
          <label v-if="client.full_name">ФИО</label>
          <MakcInputComponent
            type="text"
            placeholder="Фамилия"
            v-model="v$.client.full_name.$model"
            :class="v$.client.full_name.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="client.full_name.length > 0"
          />
        </div>
        <div class="icsl__infoWrapper-input">
          <label v-if="client.birth_date">Дата рождение</label>
          <MakcInputComponent
            type="text"
            placeholder="Дата рождение"
            v-model="v$.client.birth_date.$model"
            :class="v$.client.birth_date.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="client.birth_date.length > 0"
          />
        </div>
        <div class="icsl__infoWrapper-input">
          <label>Телефон</label>
          <div class="makc-input-wrapper" :class="v$.client.phone.$errors.length > 0 ? 'field-error' : ''">
            <input
              v-model="v$.client.phone.$model"
              type="text"
              placeholder=""
              v-mask="{
                      mask: '+7 (F##) ###-##-##',
                      tokens: {
                        F: {
                          pattern: /(?!8)\d/,
                        },
                        '#': { pattern: /\d/ },
                      },
                    }"
            />
          </div>
          <ValidationErrorComponent :errors="v$.client.phone.$errors" />
        </div>
      </div>
      <span class="xxxx">Документ, удостоверяющий личность</span>
      <span class="yyyy">для несовершеннолетнего - свидетельство о рождении</span>
      <div class="icsl__infoWrapper-row icsl__infoWrapper-row_mt">
        <div class="icsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Серия"
            :class="v$.doc.serial.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.serial.length > 0"
            v-model="v$.doc.serial.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.serial.$errors" />
        </div>
        <div class="icsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Номер"
            :class="v$.doc.number.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.number.length > 0"
            v-model="v$.doc.number.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.number.$errors" />
        </div>
      </div>
      <div class="icsl__infoWrapper-row icsl__infoWrapper-row_mt2">
        <div class="icsl__infoWrapper-input icsl__infoWrapper-input_width">
          <MakcInputComponent
            type="text"
            placeholder="Кем и когда выдан"
            :class="v$.doc.info.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.info.length > 0"
            v-model="v$.doc.info.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.info.$errors" />
        </div>
      </div>
    </div>
    <div v-if="type === 'e_statement'" class="icsl__xxxxWrapper">
      <h3>Прошу произвести страховую выплату по договору в связи с:</h3>
      <div v-if="disability_show" class="mtX">
        <input type="checkbox" name="disability" v-model="disability_checked">
        <span>Установлением инвалидности</span>
        <div v-if="disability_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label>Группа/категория инвалидности</label>
            <MakcInputComponent
              type="text" placeholder=""
              :class="v$.disability.category.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.disability.category.$model"
            />
            <ValidationErrorComponent :errors="v$.disability.category.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label class="width">Дата установления инвалидности</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.disability.date_disability.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.disability.date_disability.$model"
            >
            <ValidationErrorComponent :errors="v$.disability.date_disability.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label>Дата случая/Заболевания</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.disability.date_accident.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.disability.date_accident.$model"
            >
            <ValidationErrorComponent :errors="v$.disability.date_accident.$errors" />
          </div>
        </div>
      </div>
      <div v-if="injury_show" class="mtX">
        <input type="checkbox" name="injury" v-model="injury_checked">
        <span>Травмой</span>
        <div v-if="injury_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label>Укажите характер травмы</label>
            <MakcInputComponent
              type="text" placeholder=""
              :class="v$.injury.character.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.injury.character.$model"
            />
            <ValidationErrorComponent :errors="v$.injury.character.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label>Дата несчастного случая</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.injury.date.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.injury.date.$model"
            >
            <ValidationErrorComponent :errors="v$.injury.date.$errors" />
          </div>
        </div>
      </div>
      <div v-if="hospitalization_show" class="mtX">
        <input type="checkbox" name="injury" v-model="hospitalization_checked">
        <span>Госпитализацией</span>
        <div v-if="hospitalization_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label>Сроки госпитализации</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput" placeholder="Госпитализировали с"
              :class="v$.hospitalization.from.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.hospitalization.from.$model"
            >
            <ValidationErrorComponent :errors="v$.hospitalization.from.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <input
              type="date" :max="dateNow" class="icsl__dateInput icsl__dateInput_mt" placeholder="Госпитализировали по"
              :class="v$.hospitalization.to.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.hospitalization.to.$model"
            >
            <ValidationErrorComponent :errors="v$.hospitalization.to.$errors" />
          </div>
        </div>
      </div>
      <div v-if="surgery_show" class="mtX">
        <input type="checkbox" name="disability" v-model="surgery_checked">
        <span>Проведением хирургической операции</span>
        <div v-if="surgery_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label>Укажите операцию</label>
            <MakcInputComponent
              type="text" placeholder=""
              :class="v$.surgery.type.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.surgery.type.$model"
            />
            <ValidationErrorComponent :errors="v$.surgery.type.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label>Дата проведения операции</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.surgery.date_surgery.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.surgery.date_surgery.$model"
            >
            <ValidationErrorComponent :errors="v$.surgery.date_surgery.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label class="width2">Дата причины проведения операции</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.surgery.date_accident.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.surgery.date_accident.$model"
            >
            <ValidationErrorComponent :errors="v$.surgery.date_accident.$errors" />
          </div>
        </div>
      </div>
      <div v-if="critical_show" class="mtX">
        <input type="checkbox" name="critical" v-model="critical_checked">
        <span>Диагностированием критического заболевания</span>
        <div v-if="critical_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label>Укажите заболевание</label>
            <MakcInputComponent
              type="text" placeholder=""
              :class="v$.critical.type.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.critical.type.$model"
            />
            <ValidationErrorComponent :errors="v$.critical.type.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label>Дата диагностирования</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.critical.date.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.critical.date.$model"
            >
            <ValidationErrorComponent :errors="v$.critical.date.$errors" />
          </div>
        </div>
      </div>
      <div v-if="job_loss_show" class="mtX">
        <input type="checkbox" name="job_loss" v-model="job_loss_checked">
        <span>Потеря работы</span>
        <div v-if="job_loss_checked" class="icsl__xxxxWrapper-row">
          <div class="icsl__xxxxWrapper-input">
            <label class="width">Дата увольнения</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.job_loss.date_dismiss.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.job_loss.date_dismiss.$model"
            >
            <ValidationErrorComponent :errors="v$.job_loss.date_dismiss.$errors" />
          </div>
          <div class="icsl__xxxxWrapper-input">
            <label class="width3">Дата регистрации в службе занятости в качестве безработного</label>
            <input
              type="date" :max="dateNow" class="icsl__dateInput"
              :class="v$.job_loss.date_registration_employment.$errors.length > 0 ? 'field-error' : ''"
              v-model="v$.job_loss.date_registration_employment.$model"
            >
            <ValidationErrorComponent :errors="v$.job_loss.date_dismiss.$errors" />
          </div>
        </div>
      </div>
      <div class="icsl__xxxxWrapper-row">
        <div class="icsl__xxxxWrapper-input">
          <label>Номер договора</label>
          <MakcInputComponent
            type="text" placeholder=""
            :isDisabled="contract.number.length > 0"
            :class="v$.contract.number.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.contract.number.$model"
          />
          <ValidationErrorComponent :errors="v$.contract.number.$errors" />
        </div>
        <div class="icsl__xxxxWrapper-input">
          <label>Дата заключения договора</label>
          <input
            type="date" :max="dateNow" class="icsl__dateInput"
            :disabled="contract.date.length > 0"
            :class="v$.contract.date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.contract.date.$model"
          >
          <ValidationErrorComponent :errors="v$.contract.date.$errors" />
        </div>
      </div>
      <div class="icsl__xxxxWrapper-row">
        <div class="icsl__xxxxWrapper-input">
          <label>Обстоятельства события</label>
          <textarea v-model="conditions" class="icsl__textarea"></textarea>
        </div>
      </div>
    </div>
    <div v-if="type === 'e_statement'" class="icsl__xxxxWrapper">
      <h3>Денежные средства прошу перечислить по следующим реквизитам:</h3>
      <div class="icsl__xxxxWrapper-row mtX">
        <div class="icsl__xxxxWrapper-input">
          <label>БИК</label>
          <MakcInputComponent
            @input="autoComplit"
            type="text"
            :class="v$.requisites.bik.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.bik.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.bik.$errors" />
          <div v-if="autoComplitData.length > 0" class="bik-autocomplete">
            <p v-for="(item, i) of autoComplitData" :key="i" @click="atoInHtml(item)">
              {{ item.label }}
            </p>
          </div>
        </div>
        <div class="icsl__xxxxWrapper-input">
          <label>Корреспондентский счет банка</label>
          <MakcInputComponent
            :fieldType="'number'"
            :class="v$.requisites.ks.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.ks.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.ks.$errors" />
        </div>
      </div>
      <div class="icsl__xxxxWrapper-row mtY">
        <div class="icsl__xxxxWrapper-input">
          <label>Наименование банка</label>
          <MakcInputComponent
            type="text"
            :class="v$.requisites.bank_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.bank_name.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.bank_name.$errors" />
        </div>
        <div class="icsl__xxxxWrapper-input">
          <label>Расчетный счет</label>
          <MakcInputComponent
            type="text"
            :fieldType="'number'"
            :class="v$.requisites.rs.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.rs.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.rs.$errors" />
        </div>
      </div>
    </div>
    <div :class="type === 'e_statement' ? 'mtN' : 'mtN mtN_f'">
      <div v-show="fileInputShow">
        <MakcFilesComponent
          :text="type === 'e_statement' ? '' : 'Отправка дополнительных документов'"
          @load="loadFiles"
          ref="icslFile"
        />
      </div>
      <p v-if="sended"> Производится отправка документов, это может занять несколько минут. Пожалуйста,
        дождитесь оповещения об успешной отправке</p>
      <div v-if="errors.length > 0" class="errors">
        <div v-for="(error, key) in errors" :key="key" class="error">
          {{ error }}
        </div>
      </div>
      <div class="mtK">
        <label v-if="type === 'f_statement'" class="icsl-file" for="icsl-file">Дослать документы</label>
        <input v-if="type === 'f_statement'" id="icsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle"
               style="display: none;">
        <MakcButtonComponent
          :disabled="!agree || sended" @click="sendData" class="primary"
        >
          Отправить заявление
        </MakcButtonComponent>
        <label v-if="type === 'e_statement'" class="icsl-file" for="icsl-file">Вложить дополнительный документ</label>
        <input v-if="type === 'e_statement'" id="icsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle"
               style="display: none;">
        <MakcButtonComponent :disabled="sended" @click="modal_canceling_show = true">
          Отменить
        </MakcButtonComponent>
      </div>
    </div>
    <div class="mtP">
      <input type="checkbox" name="agree" v-model="agree">
      <p>
        Декларация Заявителя:
        <br>
        1) Настоящим Заявитель (представитель Заявителя) выражают свое согласие на обработку Страховщиком (ООО
        «МАКС-Жизнь», 115184, Москва, ул.Малая Ордынка, д.50) в течение всего срока действия указанного в настоящем
        заявлении договора страхования (далее – Договор) и в течение 25 (двадцати пяти) лет после исполнения Договора
        своих персональных данных, указанных в настоящем заявлении и иных документах, используемых Страховщиком для их
        обработки, с целью исполнения Страховщиком условий Договора и требований, установленных действующим
        законодательством, в т.ч. в целях проверки качества оказания страховых услуг и урегулирования убытков по
        Договору, осуществления страховой выплаты, администрирования договора, а также в целях информирования о
        продуктах и услугах Страховщика, в статистических целях и в целях проведения анализа. Под обработкой
        персональных данных в настоящем заявлении понимается: сбор, запись, систематизация, накопление, хранение,
        уточнение (обновление, изменение), использование, передача третьим лицам, обезличивание, блокирование, удаление,
        уничтожение персональных данных, а также совершение иных действий с персональными данными (как с использованием
        средств автоматизации, так и без использования таких средств). Настоящим Заявитель (представитель Заявителя)
        дает свое согласие Страховщику на передачу персональных данных, ставших ему известными в связи с заключением и
        исполнением Договора, третьим лицам, с которыми у Страховщика заключены соответствующие соглашения,
        обеспечивающие надежное хранение и предотвращение незаконного разглашения (конфиденциальность) персональных
        данных (включая передачу персональных данных в перестраховочную компанию). Настоящим Заявитель (представитель
        Заявителя) также подтверждают свое согласие на информирование его Страховщиком о ходе исполнения Договора, о
        продуктах и услугах Страховщика посредством направления смс- сообщений и/или сообщений по адресу электронной
        почты, указанному в настоящем заявлении. Субъект персональных данных вправе потребовать прекратить обработку
        персональных данных полностью или в части информирования о продуктах и услугах путем направления в адрес
        Страховщика письменного заявления с указанием реквизитов Договора.
        <br>
        2) Настоящим Заявитель (представитель Заявителя) подтверждает, что не имеет гражданства США, разрешения на
        постоянное пребывание в США и не является налоговым резидентом США.
        <br>
        3) Настоящим Заявитель (представитель Заявителя) подтверждает, что не является:
        <br>
        <span class="mr-2"></span>а) иностранным публичным должностным лицом, должностным лицом публичных международных
        организаций;
        <br>
        <span class="mr-2"></span>б) лицом, замещающим (занимающим) государственные должности РФ, должности членов
        Совета директоров ЦБ РФ, должности федеральной государственной службы, назначение на которые и освобождение от
        которых осуществляется Президентом РФ или Правительством РФ, должности в ЦБ РФ, государственных корпорациях и
        иных организациях, созданных РФ на основании федеральных законов, включенные в перечни должностей, определяемые
        Президентом РФ;
        <br>
        <span class="mr-2"></span>в) супругой(-ом), близким родственником лиц, указанных в настоящем подпункте.
      </p>
    </div>
    <!--  <div class="d-flex flex-row mt-5 align-items-baseline">-->
    <!--    <input class="mr-3" type="checkbox" name="sendEmail" v-model="sendEmail">-->
    <!--    <p class="mb-0 mt-0">Получать статус рассмотрения заявления по электронной почте</p>-->
    <!--  </div>-->
  </div>
  <MakcDialogComponent
    :title="'Заявление успешно подано!'"
    :text="'Отслеживать статус заявления можно в разделе “Поданные заявления”'"
    :icon="'success'"
    :width="'607px'"
    btn_text="ОК"
    @close_modal="$router.push({name: 'contract', params: {id: id}})"
    v-model:show="modal_show"
  />
  <MakcDialogComponent
    :title="'Подача заявления отменена'"
    :text="''"
    :icon="'success'"
    :width="'607px'"
    btn_text="OK"
    @close_modal="$router.push({name: 'services'})"
    v-model:show="modal_canceling_show"
  />
</template>

<script>
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import MakcInputComponent from "@/profile/components/UI/MakcInputComponent";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent";
import MakcFilesComponent from "@/profile/components/UI/MakcFilesComponent";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";
import ValidationErrorComponent from "@/profile/components/ValidationErrorComponent";
import { formatDate } from "@/profile/composables/utils";
import { mask } from "vue-the-mask";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, minLength, integer } from "@vuelidate/validators";
import { ref /*computed*/ } from "vue";

export default {
  name: "InsuranceClaimStatement",
  components: {
    MakcInputComponent,
    MakcButtonComponent,
    MakcFilesComponent,
    MakcDialogComponent,
    PreloaderComponent,
    ValidationErrorComponent
  },
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      client: {
        full_name: "",
        birth_date: "",
        phone: ""
      },
      doc: {
        serial: "",
        number: "",
        info: ""
      },
      contract: {
        number: "",
        date: ""
      },
      requisites: {
        bank_name: "",
        bik: "",
        rs: "",
        ks: ""
      },
      isLoaded: false,
      errors: [],
      files: [],
      autoComplitData: [],
      type: "e_statement",
      agree: false,
      // sendEmail: false,
      fileInputShow: false,
      sended: false,
      modal_show: false,
      modal_canceling_show: false,
      disability: {
        category: "",
        date_disability: "",
        date_accident: ""
      },
      injury: {
        character: "",
        date: ""
      },
      hospitalization: {
        from: "",
        to: ""
      },
      surgery: {
        type: "",
        date_surgery: "",
        date_accident: ""
      },
      critical: {
        type: "",
        date: ""
      },
      job_loss: {
        date_dismiss: "",
        date_registration_employment: ""
      },
      conditions: ""
    };
  },
  directives: { mask },
  setup() {
    const disability_show = ref(false);
    const disability_checked = ref(false);
    const job_loss_show = ref(false);
    const job_loss_checked = ref(false);
    const injury_show = ref(false);
    const injury_checked = ref(false);
    const hospitalization_checked = ref(false);
    const hospitalization_show = ref(false);
    const surgery_show = ref(false);
    const surgery_checked = ref(false);
    const critical_show = ref(false);
    const critical_checked = ref(false);
    const v$ = useVuelidate();

    return {
      disability_show, disability_checked,
      job_loss_show, job_loss_checked,
      injury_show, injury_checked,
      hospitalization_checked, hospitalization_show,
      surgery_show, surgery_checked,
      critical_show, critical_checked,
      v$
    };
  },
  validations() {
    return {
      client: {
        full_name: { required },
        birth_date: { required },
        phone: { required }
      },
      doc: {
        serial: { required },
        number: { required },
        info: { required, maxLength: maxLength(200) }
      },
      disability: {
        category: this.disability_show && this.disability_checked ? { required } : {},
        date_disability: this.disability_show && this.disability_checked ? { required } : {},
        date_accident: this.disability_show && this.disability_checked ? { required } : {},
      },
      injury: {
        character: this.injury_show && this.injury_checked ? { required } : {},
        date: this.injury_show && this.injury_checked ? { required } : {},
      },
      hospitalization: {
        from: this.hospitalization_show && this.hospitalization_checked ? { required } : {},
        to: this.hospitalization_show && this.hospitalization_checked ? { required } : {},
      },
      surgery: {
        type: this.surgery_show && this.surgery_checked ? { required } : {},
        date_surgery: this.surgery_show && this.surgery_checked ? { required } : {},
        date_accident: this.surgery_show && this.surgery_checked ? { required } : {},
      },
      critical: {
        type: this.critical_show && this.critical_checked ? { required } : {},
        date: this.critical_show && this.critical_checked ? { required } : {},
      },
      job_loss: {
        date_dismiss: this.job_loss_show && this.job_loss_checked ? { required } : {},
        date_registration_employment: this.job_loss_show && this.job_loss_checked ? { required } : {},
      },
      requisites: {
        bik: { required, minLength: minLength(9), maxLength: maxLength(9), integer },
        bank_name: { required, maxLength: maxLength(200) },
        rs: { required, minLength: minLength(20), maxLength: maxLength(20), integer },
        ks: { required, minLength: minLength(20), maxLength: maxLength(20), integer }
      },
      contract: {
        number: { required },
        date: { required }
      }
    };
  },
  computed: {
    dateNow() {
      return new Date().toISOString().slice(0, 10);
    },
    agreementInfoComputed() {
      return `Договор ${this.contract.number} от ${formatDate(this.contract.date)}`;
    }
  },
  methods: {
    loadFiles(item) {
      this.files = item;
    },
    async sendData() {
      this.errors = [];
      let d = new Date();
      let size = 0;
      for (let i = 0; i < this.files.length; i++) {
        size += this.files[i].file_size / 1048576;
      }

      if (size > 30) {
        this.errors.push("общий размер добавляемых файлов не может быть более 30МБ");
        return;
      }

      if (this.files.length === 0) {
        this.errors.push("Пожалуйста, приложите документы, подтверждающие факт наступления страхового события");
        return;
      }

      let unique_code = String(this.id) + String(d.getTime());
      let params;

      if (this.v$.$invalid) {
        this.v$.$touch();
        if (this.type === "f_statement") {
          params = {
            command: "send_statement_ins_claim",
            token: this.$myApp.token.get(),
            data: {
              contract_id: this.id,
              files: this.files,
              type: this.type,
              ins_date: d.toLocaleDateString("ru-RU"),
              unique_code: unique_code
            }
          };
        } else {
          this.errors.push("Для отправки заявления, пожалуйста, заполните все обязательные поля");
          return;
        }
      } else { // электронное
        if (!this.disability_checked && !this.injury_checked && !this.hospitalization_checked && !this.surgery_checked
          && !this.critical_checked && !this.job_loss_checked) {
          this.errors.push("Выберите страховое событие");
          return;
        }

        console.log()

        let risks = {};
        if (this.disability_show && this.disability_checked) {
          risks['disability'] = JSON.parse(JSON.stringify(this.disability));
        } else if (this.job_loss_show && this.job_loss_checked) {
          risks['job_loss'] = JSON.parse(JSON.stringify(this.job_loss));
        } else if (this.injury_show && this.injury_checked) {
          risks['injury'] = JSON.parse(JSON.stringify(this.injury));
        } else if (this.hospitalization_checked && this.hospitalization_show) {
          risks['hospitalization'] = JSON.parse(JSON.stringify(this.hospitalization));
        } else if (this.surgery_show && this.surgery_checked) {
          risks['surgery'] = JSON.parse(JSON.stringify(this.surgery));
        } else if (this.critical_show && this.critical_checked) {
          risks['critical'] = JSON.parse(JSON.stringify(this.critical));
        }

        params = {
          data: {
            contract_id: this.id,
            files: this.files,
            type: this.type,
            ins_date: d.toLocaleDateString("ru-RU"),
            bik: this.requisites.bik,
            bank_name: this.requisites.bank_name,
            bank_account: this.requisites.rs,
            cor_account: this.requisites.ks,
            risks: risks,
            conditions: this.conditions,
            unique_code: unique_code
          },
          command: "send_statement_ins_claim",
          token: this.$myApp.token.get()
        };
      }

      this.sended = true;
      let api = await this.$apipa.get(params);

      if (api.error) {
        this.errors = api.errors;
      }
      if (api.success) {
        this.modal_show = true;
      }
    },
    async fetchData(params) {
      try {
        let api = await this.$apipa.get(params);
        if (api.success) {
          this.client = api.data.result.client;
          this.client.full_name = `${api.data.result.client.last_name} ${api.data.result.client.first_name} ${api.data.result.client.middle_name}`;
          if (api.data.result.client.phone === "+70000000000" || api.data.result.client.phone === "+73000000000") {
            this.client.phone = ''
          }
          this.doc = api.data.result.doc;
          this.doc.info = `${api.data.result.doc.auth} ${api.data.result.doc.date} `;
          this.doc.serial = api.data.result.doc.serial_number.replace(/\s+/g, "").slice(0, 4);
          this.doc.number = api.data.result.doc.serial_number.replace(/\s+/g, "").slice(4);
          this.contract = api.data.result.contract;
          if (api.data.result.disability) this.disability_show = true;
          if (api.data.result.injury) this.injury_show = true;
          if (api.data.result.hospitalization) this.hospitalization_show = true;
          if (api.data.result.surgery) this.surgery_show = true;
          if (api.data.result.critical) this.critical_show = true;
          if (api.data.result.job_loss) this.job_loss_show = true;
        }
        if (api.error) {
          this.errors = [];
          this.errors = api.errors;
        }
        this.isLoaded = true;
      } catch (e) {
        this.errors = [];
        this.errors.push(e);
        this.isLoaded = true;
      }
    },
    atoInHtml(item) {
      this.requisites.bank_name = item.id;
      this.requisites.ks = item.cor_acc;
      this.requisites.bik = item.bic;
      this.autoComplitData = [];
    },
    async autoComplit() {
      if (this.requisites.bik.length < 3) return;
      let api = await this.$apipa.get({
        command: "autocomplit",
        action: "bic",
        term: this.requisites.bik,
        token: this.$myApp.token.get()
      });
      if (api.error) {
        if (api.errors[0].detailed === "Не указано term") {
          console.log(api);
        } else {
          // this.$myApp.errors.set(api.errors);
          this.errors = [];
          this.errors = api.errors;
        }
      }
      if (api.success) {
        this.autoComplitData = api.data.data;
      }
    },
    fileInputHandle(e) {
      this.fileInputShow = true;
      this.$refs.icslFile.loadFiles(e);
    }
  },
  mounted() {
    let params = {
      command: "ins_claim_contract",
      token: this.$myApp.token.get(),
      contract_id: this.id
    };
    this.fetchData(params);
  }
};
</script>

<style lang="scss" scoped>
.field-error {
  border: 2px solid red !important;
  outline: 2px solid red !important;
}

.makc-input-wrapper {
  position: relative;

  input {
    width: 100%;
    padding: 7px 10px;
    outline: none;
    border: 1px solid #b8b8b8;
  }

  input:disabled {
    background-color: #ecebeb;
  }
}
</style>
